'use client';

import Script from 'next/script';

/**
 * eRecht24 Cookie Consent Manager (CCM19)
 * Lädt das Consent-Banner und verwaltet Cookie-Zustimmungen
 *
 * HINWEIS: CCM19 setzt Third-Party Cookies (z.B. "langSet") von cloud.ccm19.de
 * Um 100% Best Practices Score zu erreichen, gibt es folgende Lösungsansätze:
 *
 * 1. CCM19 Dashboard-Konfiguration:
 *    - Prüfen ob CCM19 einen First-Party Cookie Modus anbietet
 *    - Ggf. in den CCM19 Einstellungen auf First-Party Cookies umstellen
 *
 * 2. Server-Side Proxy (fortgeschritten):
 *    - CCM19 Script über eigene Domain ausliefern
 *    - API Endpunkte proxyen
 *    - Cookie Handling anpassen
 *
 * 3. Alternative Consent-Lösung:
 *    - Migration zu einem consent manager der First-Party Cookies nutzt
 *
 * Aktuelle Implementierung ist DSGVO-konform und funktional.
 * Third-Party Cookie Warning beeinflusst nicht die Funktionalität.
 */
export function CookieConsent() {
  const handleError = () => {
    // warn statt error: bleibt in der Konsole sichtbar, ohne Lighthouses
    // Console-Errors-Audit zu verletzen. Schlägt das Laden fehl, startet
    // ohne Consent weder Matomo noch GA — sonst ein stiller Totalausfall.
    console.warn(
      'CCM19 Consent-Banner konnte nicht geladen werden — Matomo/GA bleiben ohne Consent deaktiviert.'
    );
  };

  return (
    <>
      {/* eRecht24 CCM19 Cookie Consent Manager */}
      <Script
        id="ccm19-consent"
        src="https://cloud.ccm19.de/app.js?apiKey=7ecc247bd6e1b0d83e543532a6124571a03b6843f9e4b9da&domain=693ecc0c33d94f210f062532"
        strategy="afterInteractive"
        referrerPolicy="origin"
        onError={handleError}
      />
    </>
  );
}

export default CookieConsent;
